import { createContext, useContext } from 'react';

type HtmlLoaderContextState = {
  canLoadHTML: boolean;
  showFilePicker: () => void;
};

const HTML_LOADER_CONTEXT_DEFAULT_VALUE: HtmlLoaderContextState = {
  canLoadHTML: false,
  showFilePicker: () => null,
};

export const HtmlLoaderContext = createContext(HTML_LOADER_CONTEXT_DEFAULT_VALUE);
export const useHtmlLoaderContext = () => useContext(HtmlLoaderContext);
